<app-wrapper header="My Details" paragraph="Keep your details up to date for your bookings">
    <app-bookingprofileform></app-bookingprofileform>
</app-wrapper>